export default {
  app: {
    privacy: {
      policy: 'Политика за поверителност',
      expansive: 'Използвайки Expansive, вие се съгласявате с Expansive {action}',
      client: '@:app.privacy.expansive{lineBreak}& {clientName} {clientAction}',
    },
    sessionExpired: 'Сесията изтече',
    sessionExpiredDescription:
      'Вашата сесия изтече. Моля, влезте отново, за да продължите да използвате приложението.',
  },
  components: {
    appContainer: {
      chooseLanguage: 'Изберете език',
      chooseLanguageDescription:
        'Изберете предпочитания от вас език за приложението. Това ще промени езика на интерфейса и съдържанието.',
    },
    userSelection: {
      cancel: 'Отказ',
      createNewUser: 'Тяхното име не е в списъка',
      newUser: 'Нов потребител',
      selectAnExistingUser: 'Изберете съществуващ потребител',
      selectUserHint: 'Изберете съществуващ потребител или създайте нов, за да продължите.',
      startTypingToSearch: 'Започнете да пишете...',
    },
    verification: {
      codeVerification: {
        continue: 'Продължи',
        header: 'Въведете код за достъп до обекта',
        invalidCode: 'Невалиден код, моля опитайте отново.',
      },
      geoVerification: {
        continueWithoutVerifying: 'Продължи без потвърждаване на местоположението',
        enterSiteAccessCode: 'Въведете код за достъп до обекта',
        locationNotEnabledOrAvailable: 'Защо виждам това?',
        notAvailable: {
          description: 'GPS местоположението не се поддържа на това устройство.',
          header: 'Местоположението не се поддържа',
        },
        notEnabled: {
          description:
            'Услугите за местоположение не са активирани или разрешението не е предоставено.',
          header: 'Местоположението не е активирано',
        },
        notVerified: {
          description: 'GPS показва, че не сте на обекта.',
          header: 'Местоположението не е потвърдено',
        },
        tryAgain: 'Опитайте отново',
        unavailable: {
          description: 'Не успяхме да потвърдим вашето GPS местоположение.',
          header: 'Местоположението не е налично',
        },
        unknown: {
          description: 'Не можем да определим вашето местоположение.',
          header: 'Местоположението е неизвестно',
        },
        verified: {
          description: 'GPS показва, че сте на обекта.',
          header: 'Местоположението е потвърдено',
        },
      },
    },
    workOrder: {
      assets: {
        emptyTitle: 'Не са намерени активи',
        emptyDescription: 'Няма активи, свързани с тази работна поръчка.',
        warrantyParts: 'Гаранцията на частите изтича',
        serialNumber: 'Сериен номер',
        none: '<няма>',
      },
      updates: {
        emptyTitle: 'Не са намерени актуализации',
        emptyDescription: 'Няма актуализации за тази работна поръчка.',
        unknownUser: 'Непознат потребител',
        none: 'Няма',
        addComment: {
          buttonLabel: 'Добави коментар',
        },
      },
      startWorkCheck: {
        startWorkCheckList: {
          hazards: 'Опасности',
          no: 'Не',
          yes: 'Да',
        },
      },
    },
    attachmentsList: {
      attachments: 'Прикачени файлове',
      documents: 'Документи',
      siteDocuments: 'Документи на обекта',
    },
  },
  stores: {
    authenticated: {
      startWorkCheckStore: {
        hazards: 'Опасности',
        induction: 'Инструктаж',
        safeToProceed: 'Безопасно е да продължите',
      },
    },
  },
  views: {
    authenticated: {
      sessions: {
        dueBy: 'Крайна дата',
        activeSessions: 'Активни сесии',
        activeSessionsDescription:
          'Вие вече сте се регистрирали в следните работни поръчки. Трябва да се откажете от тези работни поръчки, преди да се регистрирате в нова работна поръчка.',
        resumeSession: 'Продължи',
        startTime: 'Започнато в',
        unexpectedErrorTitle: 'Неочаквана грешка',
        unexpectedErrorMessage:
          'Възникна неочаквана грешка при опит за създаване на вашите сесии. Моля, опитайте отново по-късно.',
        engineerNotFound: 'Инженерът не е намерен',
        engineerNotFoundDescription:
          'Инженерът, с когото се опитвате да се регистрирате, не е намерен в системата. Моля, свържете се с вашия администратор.',
      },
      verification: {
        code: {
          description:
            'За да се регистрирате, моля, получете 4-цифрения код от управителя на обекта или определеното лице за контакт.',
        },
        geo: {
          continue: 'Продължи',
        },
      },
      workOrders: {
        checkout: {
          index: {
            signOff:
              'Моля, получете кода за достъп от мениджъра на обекта или от назначения контакт, за да завършите посещението си.',
            checkOut: 'Отказване',
            completeBeforeLeaving: 'Моля, попълнете следната форма, преди да напуснете.',
            continue: 'Продължи',
            noResolutionSelected: 'Моля, изберете разрешение, преди да продължите.',
            quoteRequired: {
              hint: 'Посещението е завършено, оферта ще последва',
              label: 'Изисква се оферта',
            },
            returnVisitRequired: {
              hint: 'Ще се върнем отново, за да завършим',
              label: 'Изисква се повторно посещение',
            },
            serviceCompleted: {
              hint: 'Не се изисква допълнително действие',
              label: 'Услугата е завършена',
            },
            uploadCheckout: 'Качете файл, снимка или видео',
            visitNotes: 'Бележки от посещението',
            workOrderResolution: 'Разрешение на работната поръчка',
            enterNotes: 'Въведете бележки тук...',
            errors: {
              timedOut: 'Времето изтече, надвишени са 30 секунди. Моля, опитайте отново.',
              closingSession: 'Грешка при затваряне на сесията',
            },
          },
          success: {
            description:
              'Благодарим ви, че посетихте {site}. | {site} все още има 1 отворена работна поръчка. | {site} все още има {count} отворени работни поръчки.',
            endVisit: 'Край на посещението',
            header: 'Успешно се отказахте',
            viewWorkOrders: 'Регистрирайте се в друга работна поръчка',
          },
          verification: {
            code: {
              description:
                'За да се откажете, моля, получете 4-цифрения код от управителя на обекта или определеното лице за контакт.',
              continue: 'Продължи',
            },
            geo: {
              checkOut: 'Отказване',
              continue: 'Продължи',
            },
          },
        },
        detail: {
          assets: 'Активи',
          call: 'Обадете се',
          checkOut: 'Отказване',
          closed: 'Затворено',
          details: 'Подробности',
          dueBy: 'Крайна дата',
          manageEngineers: 'Управление на инженерите',
          notAvailable: 'Не е налично',
          pointOfContact: 'Лице за контакт',
          siteAccessTimes: 'Часове на достъп до обекта',
          siteAccessInstructions: 'Инструкции за достъп',
          siteAddress: 'Адрес на обекта',
          siteNotes: 'Бележки за обекта',
          siteTelephone: 'Телефон на обекта',
          siteLocation: 'Местоположение на обекта',
          updates: 'Актуализации',
          more: 'Още',
          mismatchErrorTitle: 'Грешка в работната поръчка',
          mismatchErrorMessage:
            'Работната поръчка, към която се опитвате да получите достъп, не съвпада с тази, в която в момента сте регистрирани. Моля, проверете работната поръчка и опитайте отново.',
          siteDocuments: 'Документи на обекта',
          validFrom: 'Валидно от',
          validUntil: 'Валидно до',
          documentName: 'Име на документа',
          documentType: 'Тип на документа',
          attachments: 'Файлове на работната поръчка',
          download: 'Изтегляне',
          workDetails: 'Детайли за работа',
        },
        engineers: {
          assistants: {
            addAssistantEngineer: 'Добави помощен инженер',
            assistantEngineers: 'Помощни инженери',
            description:
              'По съображения за сигурност, моля, посочете имената на всеки инженер на обекта.',
            editMainEngineer: 'Редактиране на главен инженер',
            errors: {
              creatingEngineer: 'Грешка при създаване на инженера',
              creatingSession: 'Грешка при създаване на сесията',
            },
            header: 'Инженери на обекта',
            mainEngineer: 'Главен инженер',
            newAssistantEngineer: 'Въведете пълното им име',
            next: 'Напред',
            removeEngineer: 'Премахнете инженера',
            selectExistingAssistantEngineer: 'Започнете да пишете името им',
          },
          index: {
            description:
              'По съображения за сигурност, моля, посочете имената на всеки инженер на обекта.',
            errorCreatingEngineer: 'Грешка при създаване на инженера, моля опитайте отново.',
            header: 'Инженери на обекта',
            hintMainEngineer: 'Въведете пълното име на главния инженер',
            newMainEngineer: 'Нов главен инженер',
            next: 'Напред',
            selectExistingMainEngineer: 'Изберете съществуващ главен инженер',
            yes: 'Да',
            no: 'Не',
            mainEngineerLabel: 'Вие ли сте главният инженер?',
          },
        },
        index: {
          callUsOn: 'Обадете ни се на {phoneNumber}',
          description: 'Не можете да намерите това, което търсите?',
          dueBy: 'Крайна дата',
          header: 'Изберете работна поръчка',
          notAvailable: 'Не е налично',
          searchWorkOrders: 'Търсене на работни поръчки...',
        },
        manageEngineers: {
          manageEngineers: 'Управление на инженерите',
          notWorking: 'Неактивни работници',
          pause: 'Пауза',
          resume: 'Продължи',
          workingNow: 'Активни работници',
          startTime: 'Време на начало',
          endTime: 'Време на край',
          duration: 'Продължителност',
        },
        startWorkChecks: {
          feedback: {
            feedbackTitle: 'Обратна връзка',
            feedbackDescription:
              'Моля, дайте обратна връзка за работната поръчка, за да ни помогнете да подобрим услугите си.',
            feedbackLabel: 'Обратна връзка',
            filesLabel: 'Прикачени файлове',
            submissionLabel: 'Изпратете обратна връзка',
          },
          hazards: {
            back: 'Назад',
            hazards: 'Опасности',
            next: 'Напред',
            no: 'Не',
            noTasksForHazard: 'Няма задачи за изпълнение за тази опасност.',
            yes: 'Да',
          },
          induction: {
            continue: 'Продължи',
            induction: 'Инструктаж',
          },
          index: {
            checkIn: 'Регистрирайте се',
            description: 'Моля, попълнете следната оценка на риска за избраната работа.',
            fail: 'Неуспешно обработване на проверките за започване на работната поръчка.',
            haltMessage:
              'Открити потенциални рискове. Моля, прекратете работата, прегледайте указанията за безопасност и се свържете с вашия ръководител за допълнителни инструкции.',
            header: 'Проверки преди започване на работа',
            endVisit: 'Край на посещението',
            leaveFeedback: 'Оставете обратна връзка',
          },
          safeToProceed: {
            continue: 'Продължи',
            safeToProceed: 'Безопасно е да продължите',
          },
        },
      },
    },
    index: {
      title: 'Добре дошли',
      description: 'Сканирайте QR кода на вашето местоположение, за да започнете.',
    },
    login: {
      errorTitle: 'Неочаквана грешка',
      errorMessage: 'Възникна неочаквана грешка. Моля, опитайте отново сканирането на QR кода.',
    },
    unauthenticated: {
      welcome: {
        title: 'Добре дошли в {site}',
        description:
          'Преди да можем да ви покажем каквито и да било работни поръчки, трябва да проверим вашите данни. Щракнете върху бутона по-долу, за да продължите.',
        next: 'Продължи',
      },
      index: {
        errorTitle: 'Неочаквана грешка',
        errorMessage: 'Възникна неочаквана грешка. Моля, опитайте отново сканирането на QR кода.',
      },
      contractor: {
        title: 'За кого работите?',
        contractor: 'Изпълнител',
        contractorLabel: 'Започнете да пишете името на вашата компания',
        contractorHint: 'Трябва да въведете 3 или повече символа, за да видите резултати',
        defaultSelectPlaceholder: '--Моля, изберете--',
        next: 'Напред',
      },
      user: {
        title: 'Кой сте вие?',
        cancel: 'Отказ',
        createNewUserLabel: 'Името ми не е в списъка',
        existingUserLabel: 'Започнете да пишете името си',
        existingUserHint: 'Трябва да въведете 3 или повече символа, за да видите резултати',
        newUserLabel: 'Въведете пълното си име',
        next: 'Напред',
        user: 'Потребител',
      },
      verification: {
        methods: {
          add: {
            add: 'Добави метод на верификация',
            defaultSelectPlaceholder: '--Моля, изберете--',
            emailLabel: 'Имейл',
            existingMethodWarning:
              'Вече имате висяща заявка за този метод на верификация, чакаща одобрение от администратора. Добавянето на нов ще го замени.',
            method: 'Метод',
            methodLabel: 'Метод',
            mobileCountryHint: 'Моля, изберете кода на вашата страна',
            mobileCountryLabel: 'Код на мобилната страна',
            mobileHint: 'Моля, въведете мобилния си номер',
            mobileLabel: 'Мобилен',
            title: 'Добавяне на метод на верификация',
          },
          confirm: {
            confirm: 'Потвърдете',
            description: 'Моля, потвърдете метода на верификация, за да продължите.',
            label: 'Въведете кода си',
            resend: 'Изпрати отново',
            resendPrompt: 'Не получихте код?',
            title: 'Потвърдете метода на верификация',
          },
          confirmed: {
            description:
              'Ще бъдете уведомени, след като този метод на верификация бъде одобрен от вашия администратор, и тогава ще можете да го използвате за верификация на вашата идентичност.',
            forceApproval: 'Докато не бъде одобрен, нямате достъп до работните поръчки.',
            nonForceApproval:
              'Междувременно можете да продължите да имате достъп до работните поръчки с ограничен достъп.',
            nonForceApprovalButtonLabel: 'Продължи с ограничен достъп',
            title: 'Чака одобрение',
          },
          addNew: 'Добави нов метод на верификация',
          description:
            'Трябва да верифицираме вашата идентичност, за да ви предоставим пълен достъп до работната поръчка.',
          email: 'Имейл',
          hint: 'Ще изпратим линк до избрания от вас метод на верификация, който ви дава пълен достъп до работната поръчка. Ако трябва да промените някои от съществуващите методи на верификация, моля, свържете се с вашия администратор.',
          label: 'Изберете метод на верификация',
          next: 'Напред',
          pendingHint: 'Чака одобрение от вашия администратор',
          sms: 'SMS',
          title: 'Верификация',
        },
        optional: {
          hint: 'Верифицирането на вашите данни ще ви даде пълен достъп до работната поръчка',
          label: 'Искате ли да верифицирате вашите данни?',
          next: 'Напред',
          no: 'Не',
          noHint:
            'Не искам да верифицирам данните си и да продължа с ограничен достъп до работната поръчка',
          title: 'Верификация',
          yes: 'Да',
          yesHint: 'Искам да верифицирам данните си и да получа пълен достъп до работната поръчка',
        },
        sent: {
          description:
            'Линк за вход е изпратен на {identifier}. Моля, щракнете върху линка, за да завършите входа си.',
          title: 'Изпратен линк за вход',
        },
      },
    },
  },
  utils: {
    getActivityLog: {
      yesterday: 'Вчера',
      today: 'Днес',
      days: {
        monday: 'Понеделник',
        tuesday: 'Вторник',
        wednesday: 'Сряда',
        thursday: 'Четвъртък',
        friday: 'Петък',
        saturday: 'Събота',
        sunday: 'Неделя',
      },
      months: {
        january: 'Януари',
        february: 'Февруари',
        march: 'Март',
        april: 'Април',
        may: 'Май',
        june: 'Юни',
        july: 'Юли',
        august: 'Август',
        september: 'Септември',
        october: 'Октомври',
        november: 'Ноември',
        december: 'Декември',
      },
    },
  },
  composables: {
    useRedirectToError: {
      title: 'Нещо се обърка',
      message: 'Моля, опитайте отново сканирането на QR кода.',
    },
    useResolveWorkOrderEvents: {
      user: {
        unknown: 'Непознат потребител',
      },
      none: 'Няма',
      types: {
        stateTransition: 'Статусът се промени',
        contractorAssigned: 'Изпълнителят е назначен',
        engineerAssigned: 'Инженерът е назначен',
        serviceAssigned: 'Услугата е назначена',
        priorityChanged: 'Приоритетът е променен',
        actionableDateChanged: 'Променена е датата на действие',
        dueDateChanged: 'Променена е крайната дата',
        etaDateChanged: 'Променена е датата на пристигане',
        spendLimitApproved: 'Одобрен е лимитът на разходите',
        spendLimitCancelled: 'Заявката за лимит на разходите е отменена',
        spendLimitRejected: 'Отхвърлен е лимитът на разходите',
        spendLimitRequested: 'Изисква се лимит на разходите',
        jobSheetUploaded: 'Картата на работата е качена',
        slaAlertSent: 'Изпратен е алармен сигнал за нарушен срок на обслужване',
        issuedWorkPermit: 'Издадено е разрешение за работа',
        requestForServiceSent: 'Изпратена е заявка за услуга',
        comment: 'Добавен е коментар',
        unknown: 'Неизвестно събитие',
      },
      labels: {
        actionableDate: 'Дата на действие',
        comment: 'Коментар',
        file: 'Файл',
        contractor: 'Изпълнител',
        dueDate: 'Крайна дата',
        etaDate: 'Дата на пристигане',
        engineer: 'Инженер',
        priority: 'Приоритет',
        requestForService: 'Заявка за услуга',
        service: 'Услуга',
        spendLimit: 'Лимит на разходите',
        status: 'Статус',
        workPermit: 'Разрешение за работа',
      },
    },
  },
}
